import script from "./Publications.vue?vue&type=script&setup=true&lang=js"
export * from "./Publications.vue?vue&type=script&setup=true&lang=js"

import "./Publications.vue?vue&type=style&index=0&id=b600392c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b600392c"]])

export default __exports__